<script setup lang="ts">
import { ref } from 'vue';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import AddressItem from './accordionItems/AddressItem.vue';
import HoursItem from './accordionItems/HoursItem.vue';
type AddressItem = {
  id: number;
  title: string;
  type: 'addresses';
  rows: { name: string; address: string }[];
};
type HoursItem = {
  id: number;
  title: string;
  type: 'openingHours';
  rows: { label: string; ranges: string[] }[];
};

type AccordionItem = AddressItem | HoursItem;
const props = defineProps<{ items: AccordionItem[] }>();
const openId = ref<number | null>(null);

function onTransitionEnd() {
  ScrollTrigger.refresh();
}
</script>
<template>
  <div class="mx-auto max-w-content">
    <section class="accordion animate-fade">
      <article class="h-full w-full" v-for="item in items" :key="item.id">
        <button
          type="button"
          :aria-expanded="openId === item.id"
          @click="openId = openId === item.id ? null : item.id"
          class="m:px-3"
        >
          <span>{{ item.title }}</span>
          <i
            class="apple-arrow acc-icon"
            :class="openId === item.id ? '-rotate-90' : 'rotate-90'"
          ></i>
        </button>
        <Transition
          name="acc"
          @after-enter="onTransitionEnd"
          @after-leave="onTransitionEnd"
        >
          <div v-show="openId === item.id" class="acc-panel">
            <div class="acc-panel__inner">
              <AddressItem v-if="item.type === 'addresses'" :rows="item.rows" />
              <HoursItem
                v-else-if="item.type === 'openingHours'"
                :rows="item.rows"
              />
            </div>
          </div>
        </Transition>
      </article>
    </section>
  </div>
</template>

<style scoped>
.acc-panel {
  display: grid;
  grid-template-rows: 1fr;
}

.acc-panel__inner {
  overflow: hidden;
}

.acc-enter-active,
.acc-leave-active {
  transition: grid-template-rows 280ms ease-in-out;
}

.acc-enter-from,
.acc-leave-to {
  grid-template-rows: 0fr;
}

.acc-enter-to,
.acc-leave-from {
  grid-template-rows: 1fr;
}

.acc-icon {
  transition: transform 280ms ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .acc-enter-active,
  .acc-leave-active,
  .acc-icon {
    transition: none;
  }
}
</style>
